import { Heart } from "lucide-react";

const ITEMS = [
  "A Fresh Start",
  "A New Home",
  "A New Beginning",
  "Donated by the Community",
  "Offered with Dignity",
  "Reinvested in the Next Family",
];

export default function Marquee({ dark = true }) {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`whitespace-nowrap px-8 font-serif text-2xl sm:text-3xl italic ${dark ? "text-cream/90" : "text-olive/80"}`}>
            {item}
          </span>
          <Heart className={`h-4 w-4 shrink-0 fill-current ${dark ? "text-gold" : "text-burgundy"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${dark ? "border-olive-deep bg-olive" : "border-linen bg-beige"}`}
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
